




































import AulaButton from '../../components/AulaButton.vue';
import Editor from '../../../shared/components/Editor/index.vue';
import Icon from '../../components/Icon.vue';
import { iconClassEnum } from '../../enums/iconClassEnum';
import { mapActions } from 'vuex';
import { types } from '../../../src/store/types/types.js';
import { eventTypeEnum } from '../../enums/eventTypeEnum';
import { portalRoles } from '../../enums/portalRoles';
import { eventResponseStatus } from '../../enums/eventResponseStatus';
import { DateTimeUtil } from '../../utils/dateTimeUtil';
import AulaInfoTrigger from "../../components/AulaInfoTrigger.vue";

export default {
  components: { AulaInfoTrigger, Icon, AulaButton, Editor },
  props: {
    eventData: { type: Object, required: true },
  },
  emits: ['reminderSent'],
  data() {
    return {
      reminderMessage: '',
      isValid: true,
      isValidReminderMessage: true,
      portalRoles: portalRoles,
      isLoading: false,
      isShown: false,
    };
  },
  computed: {
    canSendReminder() {
      const isRepeating = this.eventData.repeating != null;
      let isDeadlineExceeded = this.eventData.isDeadlineExceeded;
      if (!this.eventData.responseDeadline) {
        isDeadlineExceeded = DateTimeUtil.isSameOrBefore(this.eventData.endDateTime, new Date());
      }
      return !isRepeating && !isDeadlineExceeded;
    },
    iconClassEnum() {
      return iconClassEnum;
    },
    isVacationRequest() {
      return this.eventData.type === eventTypeEnum.VACATION_REGISTRATION;
    },
    isMeeting() {
      return (
        this.eventData.type === eventTypeEnum.SCHOOL_HOME_MEETING ||
        this.eventData.type === eventTypeEnum.PARENTAL_MEETING ||
        this.eventData.type === eventTypeEnum.PERFORMANCE_MEETING
      );
    },
    warningText() {
      if (this.isVacationRequest) {
        return this.$getText('CALENDAR_SEND_VACATION_REQUEST_REMINDER_WARNING', {
          numberOfInvitees: this.eventData.vacationRegistration.childrenPendingAnswers.length,
        });
      }

      let waitingInvitees = this.eventData.invitees.filter(
        invitee => invitee.responseType === eventResponseStatus.WAITING
      );

      if (this.isMeeting) {
        waitingInvitees = waitingInvitees.filter(invitee => invitee.instProfile.role !== portalRoles.CHILD);
      }

      const waitingOtps = this.eventData.invitedGroupHomeChildren.filter(
        invitee => invitee.responseType === eventResponseStatus.WAITING
      );

      const inviteeCount = waitingInvitees.length + waitingOtps.length;

      return this.$getText('CALENDAR_SEND_EVENT_REMINDER_WARNING', {
        numberOfInvitees: inviteeCount,
      });
    },
    reminderMessageText() {
      if (this.isVacationRequest) {
        return this.$getText('CALENDAR_VACATION_REQUEST_REMINDER_MESSAGE');
      }
      return this.$getText('CALENDAR_EVENT_REMINDER_MESSAGE');
    },
    autoGeneratedText() {
      return this.$getText('CALENDAR_EVENT_REMINDER_AUTO_GENERATED');
    },
  },
  mounted() {
    this.initReminderMessage();
  },
  methods: {
    ...mapActions({
      sendReminder: types.SEND_EVENT_REMINDER,
      loadEventById: types.GET_EVENT_BY_ID,
    }),
    initReminderMessage() {
      this.reminderMessage = `<div>${this.reminderMessageText}</div>\r\n<div><em>(${this.autoGeneratedText})</em></div>`;
    },
    validateReminderMessage() {
      this.isValidReminderMessage = this.reminderMessage.length > 0;
    },
    validateReminder() {
      if (!this.isValidReminderMessage) {
        this.isValid = false;
      }
    },
    resetReminderStates() {
      this.isValidReminderMessage = true;
      this.isValid = true;
    },
    async onSendReminderClicked() {
      this.validateReminder();
      if (!this.isValid) {
        return;
      }
      this.isLoading = true;
      try {
        await this.sendReminder({
          eventId: this.eventData.id,
          message: this.reminderMessage,
        });
      } catch {
        this.isValid = false;
      }
      this.isLoading = false;
      this.$refs.sendReminderWarningModal.hide();
      this.$emit('reminderSent');
    },
    openSendReminderModal() {
      this.$refs.sendReminderWarningModal.show();
    },
  },
};
